export const blockIconsTransportationDirectionsBoatNew = (
	<span className='material-symbols-outlined'>directions_boat</span>
);
